var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_vm._v(" 決定を押して移管完了"),_c('br'),_c('v-btn',{on:{"click":_vm.back}},[_vm._v("戻る")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }